export default {
  title: "Prenotazioni",
  descriptionSeller: "Gestisci tutte le prenotazioni delle tue attività",
  descriptionHost: "Gestisci le prenotazioni delle tue attività",
  descriptionAdmin:
    "Visualizza prenotazioni e conversazioni handshake di questo venditore",
  adminScopeTitle: "Scegli prima un venditore",
  adminScopeAction: "Vai agli utenti",
  adminScopeRequired:
    "Apri il dettaglio di un venditore e usa Vedi prenotazioni per visualizzarle.",
  backToPartner: "Torna al venditore",
  descriptionCustomer: "Visualizza le prenotazioni e carica gli scontrini",
  sellerIdMissing: "ID utente venditore non trovato",
  errorLoad: "Errore nel caricamento delle prenotazioni",
  viewSelectorLabel: "Vista",
  viewList: "Elenco",
  viewCalendar: "Calendario",
  calendar: {
    previousWeek: "Settimana precedente",
    nextWeek: "Settimana successiva",
    today: "Oggi",
    todayBadge: "Oggi",
    openDay: "Vedi {{count}} appuntamenti il {{date}}",
    emptyDay: "Nessun appuntamento",
    emptyDayDescription:
      "Non ci sono prenotazioni programmate per questo giorno.",
    dayStripEmpty: "—",
    dayStripSummary: "{{bookings}} pren · {{covers}} osp",
    daySummaryWithCovers_one:
      "{{count}} prenotazione · {{covers}} ospiti totali",
    daySummaryWithCovers_other:
      "{{count}} prenotazioni · {{covers}} ospiti totali",
  },
  cardTitle: "Prenotazioni",
  needsAttention: {
    title: "Richiedono attenzione",
    subtitle_one: "{{count}} prenotazione richiede la tua attenzione",
    subtitle_other: "{{count}} prenotazioni richiedono la tua attenzione",
    allClearTitle: "Tutto a posto",
    allClearSubtitle: "Nulla richiede attenzione al momento",
    seeAllBookings: "Vedi tutte le prenotazioni",
    showAll: "Mostra tutte ({{count}})",
    showAllTitle: "Prenotazioni da gestire",
  },
  stats: {
    tile: {
      confirmation: "Da confermare",
      receipts: "Scontrini da caricare",
      guests: "Ospiti oggi",
      completion: "Visite da completare",
    },
  },
  activityFilter: {
    label: "Attività",
    allActivities: "Tutte le attività",
    optionWithCount: "{{name}} ({{count}})",
  },
  statusFilter: {
    label: "Stato",
    any: "Tutti gli stati",
    optionWithCount: "{{name}} ({{count}})",
  },
  actionFilters: {
    label: "Filtra per azione",
    all: "Tutte le azioni",
    confirmation: "In attesa di conferma",
    receipt: "Scontrino da caricare",
    completion: "Visita non completata",
  },
  manageModal: {
    emptyTitle: "Niente da fare",
    emptyDescription:
      "Tutte le prenotazioni sono aggiornate — nessuna azione richiesta.",
    completeConfirmTitle: "Segnare visita completata?",
    completeConfirmMessage:
      "Questo segnerà la prenotazione come completata dopo la visita.",
  },
  partyItems: {
    andMore_one: "+{{count}} altro",
    andMore_other: "+{{count}} altri",
  },
  list: {
    undatedSection: "Senza data visita",
  },
  bookingCount_one: "{{count}} prenotazione",
  bookingCount_other: "{{count}} prenotazioni",
  loading: "Caricamento prenotazioni...",
  emptyTitle: "Nessuna prenotazione ancora",
  emptyDescription:
    "Le prenotazioni dei clienti appariranno qui quando riceverai la prima",
  emptyFilteredTitle: "Nessuna prenotazione con questi filtri",
  emptyFilteredDescription:
    "Prova un altro stato o un’altra attività, oppure azzera i filtri per vedere di più.",
  unknownActivity: "Attività sconosciuta",
  guest_one: "{{count}} ospite",
  guest_other: "{{count}} ospiti",
  kioskBookingTitle: "Tablet usato per questa prenotazione",
  receiptUploadErrorTitle: "Errore nel caricamento dello scontrino",
  receiptUploadErrorMessage:
    "Si è verificato un errore durante il caricamento o l’analisi dello scontrino. Riprova.",
  receiptConfirmErrorTitle: "Errore nella conferma dello scontrino",
  receiptConfirmErrorMessage:
    "Si è verificato un errore durante la conferma dello scontrino. Riprova.",
  toastReceiptAlready: "Scontrino già registrato per questa prenotazione.",
  toastPointsAwarded: "Scontrino confermato! +{{points}} punti fedeltà",
  toastPartnerUploaded: "Scontrino caricato correttamente. Totale: {{total}}",
  receiptOcrUnreadableTitle: "Scontrino illeggibile",
  receiptOcrUnreadableFallback:
    "Impossibile leggere il totale dallo scontrino. Ripeti la foto in modo più nitido.",
  receiptManualRequiredTitle: "Totale manuale richiesto",
  receiptManualCta: "Inserisci totale",
  receiptManualRequiredMessage:
    "I tentativi di validazione dello scontrino sono esauriti. Inserisci l'importo totale manualmente.",
  toastPartnerManualAmount: "Totale scontrino manuale salvato: {{total}}",
  alertGotIt: "Ho capito",
  emptyDescriptionCustomer:
    "Le tue prenotazioni appariranno qui. Carica gli scontrini delle visite completate per guadagnare punti.",
  status: {
    CREATED: "In attesa di pagamento",
    PENDING_HANDSHAKE: "Handshake in sospeso",
    ACCEPTED: "Accettata",
    REJECTED: "Rifiutata",
    COMPLETED: "Completata",
    CANCELED: "Annullata",
    ABANDONED: "Scaduta",
    unknown: "Stato sconosciuto",
  },
  partnerStatus: {
    pending: "In attesa",
    confirmed: "Confermata",
  },
  handshake: {
    messageCount_one: "{{count}} messaggio",
    messageCount_other: "{{count}} messaggi",
    loading: "Caricamento conversazione...",
    loadError: "Impossibile caricare la conversazione handshake",
    notFound: "Conversazione handshake non trovata",
  },
  detail: {
    loading: "Caricamento prenotazione...",
    loadError: "Impossibile caricare questa prenotazione",
    notFound: "Prenotazione non trovata",
    backToList: "Torna alle prenotazioni",
    orderInfo: "Dettagli ordine",
    bookingSummary: "Prenotazione",
    requestedVisit: "Data richiesta",
    bookingType: "Tipo di prenotazione",
    bookingTypes: {
      restaurant: "Prenotazioni ristorante",
      service: "Prenotazioni servizio",
    },
    handshakeActions: "Azioni",
    chatSectionTitle: "Chat handshake",
    chatChannelCustomer: "{{channel}} — {{name}}",
    chatClosedBadge: "Chiusa",
    moreActions: "Altre azioni",
    supportHelpAction: "Apri ticket di supporto",
    supportTicketSubject: "Prenotazione {{id}}",
    completeSectionTitle: "Completa visita",
    completeSectionDescription:
      "Segna questa prenotazione come completata dopo la visita.",
    completeSectionAction: "Segna completata",
    receiptSectionTitle: "Carica scontrino",
    receiptSectionDescription:
      "Carica una foto dello scontrino per completare questa prenotazione e calcolare la commissione.",
    receiptManualSectionTitle: "Inserisci totale scontrino",
    receiptManualSectionDescription:
      "I tentativi di validazione sono esauriti. Inserisci il totale manualmente per completare questa prenotazione.",
    cancelBookingBusy: "Annullamento in corso...",
    cancelBookingSuccess: "Prenotazione annullata",
    cancelBookingError: "Impossibile annullare questa prenotazione",
    cancelBookingPastVisitError:
      "Non è possibile annullare una prenotazione dopo la data dell'incontro",
    cancelBookingConfirmTitle: "Annullare questa prenotazione?",
    cancelBookingConfirmMessage:
      "Il cliente verrà rimborsato quando previsto. Questa azione non può essere annullata.",
        cancelBookingConfirmMessageAdmin:
      "Cancel booking for {{name}} ({{amount}})? The refund starts automatically and cannot be undone.",
cancelBookingConfirmAction: "Annulla prenotazione",
    statusInsight: {
      abandonedTitle: "Pagamento scaduto",
      abandonedDescription:
        "Il cliente non ha completato il pagamento in tempo. Non si tratta di un annullamento — la prenotazione non è mai stata confermata.",
    },
    cancellationSource: {
      label: "Annullata da",
      customer: "Cliente",
      partner: "Partner",
      system: "Sistema",
    },
    markComplete: "Segna visita completata",
    markCompleteBusy: "Completamento in corso...",
    markCompleteSuccess: "Visita segnata come completata",
    markCompleteError: "Impossibile segnare la prenotazione come completata",
    chatViaChannel: "Chat tramite {{channel}}",
    receipt: "Scontrino",
    noHandshake: "Nessuna conversazione handshake per questa prenotazione",
    bookingId: "ID prenotazione",
    services: "Servizi",
    visitDate: "Data visita",
    visitTime: "Ora visita",
    partySize: "Ospiti / quantità",
    customerName: "Cliente",
    email: "Email",
    phone: "Telefono",
    kiosk: "Tablet / dispositivo",
    generatingDevice: "Dispositivo generatore",
    hostingStructure: "Struttura ospitante",
    unnamedDevice: "Dispositivo senza nome",
    total: "Totale",
    amountPaid: "Importo pagato",
    depositPaid: "Acconto incassato",
    dueAtVenue: "Da incassare in loco",
    listPrice: "Prezzo di listino",
    sellerDiscount: "Sconto partner",
    sellerDiscountBadge: "Sconto partner",
    sellerDiscountNote:
      "Questo sconto l’hai impostato tu — il tuo compenso è calcolato sul prezzo servizio dopo questo markdown.",
    servicePrice: "Prezzo servizio",
    flitripDiscount: "Sconto Flitrip",
    flitripDiscountBadge: "Sconto Flitrip",
    flitripDiscountNote:
      "Il tuo compenso resta calcolato sul prezzo servizio — questo sconto è a carico di Flitrip.",
    pointsDiscount: "Sconto punti",
    customerPaid: "Cliente ha pagato",
    createdAt: "Prenotato il",
    customerNotes: "Note cliente",
    sellerNotes: "Note venditore",
  },
  adminDetail: {
    tabs: {
      label: "Sezioni del dettaglio prenotazione",
      overview: "Panoramica",
    },
    ids: {
      title: "Riferimenti tecnici",
      hint: "ID copiabili per supporto e sviluppatori",
      handshakeSession: "Sessione handshake",
      externalPayment: "Pagamento esterno",
    },
    localTime: "({{time}} ora locale)",
    sections: {
      parties: "Parti coinvolte",
      customer: "Cliente",
      booking: "Prenotazione",
      payment: "Pagamento",
      receipt: "Scontrino",
      chat: "Chat handshake",
    },
    timeline: {
      steps: {
        CREATED: "Creata",
        PENDING_HANDSHAKE: "In attesa di handshake",
        ACCEPTED: "Accettata",
        COMPLETED: "Completata",
        REJECTED: "Rifiutata",
        CANCELED: "Annullata",
        ABANDONED: "Scaduta",
      },
    },
    phone: {
      reveal: "Mostra",
      hide: "Nascondi",
      confirmTitle: "Mostrare il telefono del cliente?",
      confirmMessage:
        "L'accesso al numero di telefono del cliente viene registrato. Mostralo solo se devi contattare il cliente per supporto.",
      confirmAction: "Mostra telefono",
      revealError: "Impossibile mostrare il telefono",
    },
    partner: {
      activity: "Attività",
      name: "Seller",
    },
    payment: {
      none: "Nessun pagamento esterno collegato a questa prenotazione",
      noAccess: "Non hai il permesso di visualizzare i pagamenti esterni",
      models: {
        UPFRONT: "Upfront",
        DEPOSIT: "Deposito",
        RECEIPT_BASED: "Basato su scontrino",
      },
      amount: "Importo pagamento",
      providerId: "ID pagamento provider",
      viewPayment: "Vedi nei pagamenti",
      sellerDiscountNote:
        "Markdown a carico del partner — il compenso del partner è calcolato sul prezzo servizio dopo questo sconto.",
      flitripDiscountNote:
        "Promo a carico della piattaforma — il compenso del partner resta sul prezzo servizio; Flitrip copre questo sconto.",
    },
    economicEvents: {
      title: "Eventi economici",
      none: "Nessun evento economico collegato ancora",
      noAccess: "Non hai il permesso di visualizzare gli eventi economici",
      viewEvent: "Vedi evento",
    },
    commissions: {
      activityShort: "Attività",
      houseShort: "Struttura",
    },
    structure: {
      none: "Nessuna struttura ospitante collegata",
      host: "Host",
    },
    language: "Lingua",
    lineItems: {
      qtyUnit: "{{qty}} × {{unit}}",
    },
    receipt: {
      noneYet: "Nessuno scontrino partner registrato ancora",
      manualRequired: "È richiesto l'importo scontrino manuale",
      auditTitle: "Cronologia caricamenti scontrino",
      auditEmpty: "Nessun caricamento scontrino ancora",
      viewUpload: "Vedi immagine scontrino",
      viewUploadError: "Impossibile aprire l'immagine dello scontrino",
      manualRegistered: "Importo manuale registrato",
      amountSource: {
        OCR: "Registrato da OCR",
        MANUAL: "Registrato manualmente",
      },
      uploadStatus: {
        uploaded: "Caricato",
        ocr_succeeded: "OCR riuscito",
        ocr_failed: "OCR fallito",
        partner_rejected: "Rifiutato dal partner",
        confirmed: "Confermato",
      },
    },
    salesAgent: {
      none: "Nessun agente di commercio assegnato a questa attività",
      name: "Agente di commercio",
    },
    chat: {
      readOnlyHint: "La chat è in sola lettura in questa pagina.",
    },
  },
  adminReceiptAdjust: {
    title: "Modifica totale scontrino",
    description:
      "Totale registrato attuale: {{current}}. Verrà stornata l'allocazione commissione esistente e ne verrà creata una nuova.",
    amountLabel: "Nuovo totale scontrino (EUR)",
    amountPlaceholder: "es. 125,50",
    reasonLabel: "Motivo (opzionale)",
    reasonPlaceholder: "Perché viene corretto questo totale?",
    submit: "Salva nuovo totale",
    action: "Modifica totale scontrino",
    success: "Totale scontrino aggiornato a {{total}}",
    error: "Impossibile aggiornare il totale scontrino",
    invalidAmount: "Inserisci un importo valido maggiore di zero",
    sameAmount:
      "Il nuovo totale deve essere diverso dal totale attuale dello scontrino",
  },
  sellerNotesModal: {
    title: "Note venditore",
    description: "Note interne per il tuo team. I clienti non possono vederle.",
    placeholder: "Aggiungi note su questa prenotazione...",
    add: "Aggiungi note",
    edit: "Modifica note",
    save: "Salva note",
    saveSuccess: "Note venditore salvate",
    saveError: "Impossibile salvare le note venditore",
    emptyDetail: "Nessuna nota venditore aggiunta.",
  },
} as const;
